var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      ref: "elTable",
      staticStyle: { width: "100%" },
      attrs: { border: "", data: _vm.tableData, "max-height": _vm.maxHeight },
    },
    [
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "provider",
          label: this.$t("InternalSalesOrderDetailsSearchTable.providerss"),
          "min-width": "125",
        },
      }),
      !_vm.$store.getters.cusId
        ? _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "totalPrice",
              label: this.$t("InternalSalesOrderDetailsSearchTable.totalPrice"),
              "min-width": "125",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(_vm.formatTotalPrice(scope.row)))]
                  },
                },
              ],
              null,
              false,
              1246340126
            ),
          })
        : _vm._e(),
      !_vm.$store.getters.cusId
        ? _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "ratePrice",
              label: this.$t("billingPage.ratePrice"),
              "min-width": "125",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          scope.row.ratePrice
                            ? (scope.row.ratePrice - 0).toFixed(2)
                            : scope.row.ratePrice
                        )
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3705460763
            ),
          })
        : _vm._e(),
      _vm.$store.getters.cusId
        ? _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "ratePrice",
              label: this.$t("billingPage.costPrice"),
              "min-width": "125",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          scope.row.ratePrice
                            ? (scope.row.ratePrice - 0).toFixed(2)
                            : scope.row.ratePrice
                        )
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3705460763
            ),
          })
        : _vm._e(),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "responseCode",
          label: this.$t("InternalSalesOrderDetailsSearchTable.responseCode"),
          "min-width": "125",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "name-wrapper",
                    attrs: { slot: "reference" },
                    slot: "reference",
                  },
                  [
                    _vm._v(" " + _vm._s(scope.row.responseCode) + " "),
                    scope.row.responseCode == "FAILED"
                      ? _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "red" },
                        })
                      : _vm._e(),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "responseMsg",
          label: this.$t("InternalSalesOrderDetailsSearchTable.failReason"),
          "min-width": "200",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  _vm._s(
                    scope.row.responseCode == "FAILED"
                      ? scope.row.responseMsg
                      : ""
                  )
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "creationDate",
          label: this.$t("InternalSalesOrderDetailsSearchTable.creationDate"),
          "min-width": "130",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  _vm._s(
                    _vm._f("timeFilters")(
                      scope.row.creationDate,
                      scope.row.creationDate
                    )
                  )
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }